'use client';

import { useTranslation } from 'next-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface MissionChipProps {
  label: string;
  /** Destination on click. Defaults to site root. */
  href?: string;
}

export const MissionChip = ({ label, href = '/' }: MissionChipProps) => {
  const { t } = useTranslation('common');

  const handleClick = () => {
    if (typeof window === 'undefined') return;
    window.location.assign(href);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => e.preventDefault()}
      aria-label={t('global.label.reset.mission', 'Reset mission')}
      title={label}
      className="group flex shrink-0 items-center gap-1 rounded-full bg-surface-100 px-2.5 py-1 text-xs text-ink transition-colors hover:bg-surface-200 lg:text-sm"
    >
      <span className="max-w-40 truncate">{label}</span>
      <XMarkIcon
        aria-hidden
        className="size-3.5 shrink-0 text-ink-medium opacity-0 transition-opacity group-hover:opacity-100"
      />
    </button>
  );
};
